// extracted by mini-css-extract-plugin
export default {"link":"embeddedVideo_link__QbtrN","pagination":"embeddedVideo_pagination__69a1w","container":"embeddedVideo_container__1pQIa"};